import { render, staticRenderFns } from "./ObstacleDetail.vue?vue&type=template&id=8820baca&scoped=true"
import script from "./ObstacleDetail.vue?vue&type=script&lang=js"
export * from "./ObstacleDetail.vue?vue&type=script&lang=js"
import style0 from "./ObstacleDetail.vue?vue&type=style&index=0&id=8820baca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8820baca",
  null
  
)

export default component.exports